import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserId } from "../../services/authService";
import { getCategories } from "../../services/categoryService";
import {
  createRecurringTransaction,
  createTransaction,
  getVendors,
} from "../../services/transactionService";
import { useGroupContext } from "../Groups/useGroupContext";
import TransactionForm from "./TransactionForm";

const AddTransaction = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryType = queryParams.get("type") || "EXPENSE";
  const isRecurring =
    queryParams.get("recurring") === "true" ? true : false || false;
  const { getContextParams } = useGroupContext();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const contextParams = getContextParams();
        const categoriesData = await getCategories(contextParams);
        setCategories(categoriesData);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    const fetchVendors = async () => {
      try {
        const contextParams = getContextParams();
        const vendorsList = await getVendors(contextParams);
        setVendors(vendorsList);
      } catch (error) {
        console.error("Error fetching vendors list:", error);
      }
    };

    fetchCategories();
    fetchVendors();
  }, [getContextParams]);

  const handleCreate = async (newTransaction) => {
    const userId = await getUserId();
    if (!userId) {
      alert("User not authenticated");
      return;
    }

    const contextParams = getContextParams();
    //newTransaction.userId = contextParams.context === 'group' ? null : userId;

    newTransaction.userId = userId;

    const category = categories.find(
      (cat) =>
        cat.name === newTransaction.category_name &&
        cat.type === newTransaction.category_type
    );

    if (!category) {
      alert("Category not found!");
      return;
    }
    newTransaction.categoryid = category.id;

    if (newTransaction.isRecurring) {
      newTransaction.start_date = newTransaction.date;
      newTransaction.next_due_date = calculateEndDate(
        newTransaction.date,
        newTransaction.frequency,
        2
      );
      newTransaction.end_date = newTransaction.isPermanent
        ? null
        : calculateEndDate(
            newTransaction.date,
            newTransaction.frequency,
            newTransaction.recurringcount
          );
      newTransaction.recurringcount--;
      if (newTransaction.isPermanent) {
        newTransaction.recurringcount = null;
      }
      const response = await createRecurringTransaction(
        newTransaction,
        contextParams
      );
      if (response.status !== 200 && response.status !== 201) {
        alert("Failed to add recurring transaction.");
      }

      const response2 = await createTransaction(newTransaction, contextParams);
      if (response2.status !== 200 && response2.status !== 201) {
        alert("Failed to add recurring transaction.");
      }
      navigate("/recurring-payments");
    } else {
      const response = await createTransaction(newTransaction, contextParams);
      if (response.status === 200 || response.status === 201) {
        alert(`Transaction added successfully!`);
        navigate(
          newTransaction.category_type === "INCOME"
            ? "/income"
            : newTransaction.category_type === "INVESTMENT"
            ? "/investments"
            : newTransaction.isRecurring
            ? "/recurring-payments"
            : "/expenses"
        );
      } else {
        alert("Failed to update transaction.");
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <TransactionForm
        isEdit={false}
        onSubmit={handleCreate}
        categories={categories}
        vendors={vendors}
        initialCategoryType={categoryType}
        initialRecurring={isRecurring}
      />
    </Container>
  );
};

const calculateEndDate = (date, frequency, recurringcount) => {
  if (!date || !recurringcount) return null;

  const startDate = new Date(date);
  const count = parseInt(recurringcount, 10) - 1;

  if (isNaN(count) || count <= 0) return null;

  switch (frequency) {
    case "DAILY":
      startDate.setDate(startDate.getDate() + count);
      break;
    case "WEEKLY":
      startDate.setDate(startDate.getDate() + count * 7);
      break;
    case "MONTHLY":
      startDate.setMonth(startDate.getMonth() + count);
      break;
    case "YEARLY":
      startDate.setFullYear(startDate.getFullYear() + count);
      break;
    default:
      return null;
  }
  startDate.setHours(12, 0, 0, 0);
  return startDate.toISOString().split("T")[0];
};

export default AddTransaction;
